<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_search') ||
                '选品名称/选品面料/工厂/客户/原始样品 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="form" :model="form" size="mini">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('form_lable_status') || '状态'">
              <dict-select
                v-model="form.devStatusList"
                url="/sys/common/dict/system"
                :body="devStatusParams"
                :placeholder="$l('please_label_Status') || '请选择...'"
                filterable
                clearable
                multiple
                size="mini"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_devTrackingNo') || '开发跟踪编号'"
            >
              <el-input
                v-model.trim="form.devTrackingNo"
                :placeholder="
                  $l('please_label_devTrackingNo') || '请输入开发跟踪编号...'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_proposalStyleNo') || '样品款号'"
            >
              <el-input
                v-model.trim="form.proposalStyleNo"
                :placeholder="
                  $l('please_label_proposalStyleNo') || '请输入样品款号...'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_sampleName') || '样品中文名称'"
            >
              <el-input
                v-model.trim="form.sampleName"
                :placeholder="
                  $l('please_label_sampleName') || '请输入样品中文名称...'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_sampleNameEn') || '样品英文名称'"
            >
              <el-input
                v-model.trim="form.sampleNameEn"
                :placeholder="
                  $l('please_label_sampleNameEn') || '请输入样品英文名称...'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$l('form_label_createByList') || '选品人'">
              <dict-select
                v-model="form.createByList"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('please_label_createBy') || '请选择选品人...'"
                clearable
                filterable
                multiple
                size="mini"
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$l('form_label_modifyByList') || '变动人'">
              <dict-select
                v-model="form.modifyByList"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('please_label_modifyBy') || '请选择变动人...'"
                clearable
                filterable
                multiple
                size="mini"
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$l('form_label_scmName') || '工厂'">
              <dict-select
                v-model="form.sampleScmCodeList"
                url="/master/common/dict/allScmCooperated"
                :placeholder="$l('please_label_sampleScm') || '请选择工厂...'"
                clearable
                filterable
                multiple
                size="mini"
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$l('form_label_endCustName') || '终端客户'">
              <dict-select
                v-model="form.endCustCodeList"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('please_label_endCust') || '请选择终端客户...'"
                clearable
                filterable
                multiple
                size="mini"
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$l('form_label_categoryCode') || '品类'">
              <dict-select
                v-model="form.categoryCodeList"
                url="/master/masterCategory/select"
                :placeholder="$l('please_label_category') || '请选择品类...'"
                clearable
                filterable
                multiple
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_product_source') || '选品来源'"
            >
              <dict-select
                ref="expoInfoSelect"
                v-model="form.expoMeetingCodeList"
                url="/digitalCenter/expo/meeting/tsk/dictSelect"
                :placeholder="
                  $l('please_label_expoMeeting') || '请选择选品来源...'
                "
                filterable
                clearable
                multiple
                size="mini"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item :label="$l('form_lable_create_date') || '创建时间'">
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="createDateStartPicker"
                    :placeholder="$l('please_label_create_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="createDateEndPicker"
                    :placeholder="$l('please_label_create_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item
                :label="$l('form_label_modification_date') || '修改时间'"
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyDateStartPicker"
                    :placeholder="
                      $l('please_label_modification_date') || '请选择修改时间'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyDateEndPicker"
                    :placeholder="
                      $l('please_label_modification_date') || '请选择修改时间'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  devStatusList: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'],
}
export default {
  data() {
    return {
      devStatusParams: { dictType: 'devStatus' },
      advqueryDialogVisible: false,
      form: { ...initForm },
      //创建日期限制
      createDateStartPicker: this.createDateEnd(),
      createDateEndPicker: this.createDateStart(),
      //修改日期限制
      modifyDateStartPicker: this.modifyDateEnd(),
      modifyDateEndPicker: this.modifyDateStart(),
    }
  },

  mounted() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    // 创建日期限制
    createDateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.createDateEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.createDateEnd).getTime() < time.getTime()
          }
        },
      }
    },
    createDateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.createDateStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.createDateStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 修改时间限制
    modifyDateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyDateEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.modifyDateEnd).getTime() < time.getTime()
          }
        },
      }
    },
    modifyDateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyDateStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.modifyDateStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
